import styled from 'styled-components'

// Container for the entire proof gallery view including header, image, and navigation sections
export const ProofGalleryContainer = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  width: 100%;
  padding: 32px 24px 48px 24px;
  background-color: #f8f9fb;
`

// Wrapper for loading and error states to center messaging within the viewport
export const ProofGalleryMessageWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  padding: 24px 24px 24px 24px;
  background-color: #ffffff;
`

// Header that displays the gallery title and current pagination information
export const ProofGalleryHeader = styled.header`
  display: flex;
  width: 100%;
  max-width: 960px;
  align-items: center;
  justify-content: space-between;
  padding: 24px 0 24px 0;
`

// Right-aligned cluster within the header (page indicator + actions)
export const ProofGalleryHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`

// Wrapper that keeps the active proof image centered within the available space
export const ProofGalleryImageWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 960px;
  background-color: #ffffff;
  box-shadow: 0 12px 24px rgba(16, 30, 71, 0.08);
  border-radius: 12px;
  padding: 32px 32px 32px 32px;
`

// Responsive proof image that scales to fit while maintaining aspect ratio
export const ProofGalleryImage = styled.img`
  width: 100%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
  background-color: #ffffff;
`

// Navigation bar housing previous and next controls beneath the proof image
export const ProofGalleryNavigation = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 960px;
  gap: 16px;
  margin: 32px 0 0 0;
`
